import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { FiltersFactory } from './filters.factory';
import { GetFilter } from './models/filter.model';
import { GetFilterResponse } from './models/filter-response.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FiltersService {
  private readonly http = inject(HttpClient);
  private readonly filtersFactory = inject(FiltersFactory);

  getFilter(name: string, params: Record<string, string | number | boolean>): Observable<GetFilter> {
    const url = `${environment.apiUrl}/records/filters/${name}`;

    return this.http.get<GetFilterResponse>(url, { params }).pipe(
      map((response) => this.filtersFactory.buildGetFilterFromResponse(response))
    );
  }
}
